import { useEffect, useState } from 'react';

import { useCurrentUserQuery } from '@/shared/legacy/hooks/useCurrentUserQuery';
import { useDictionary } from '@/shared/lib/i18n';
import { InterviewType } from '../../model';
import { InterviewError, InterviewValue } from './InterviewTypeSelection.types';
import { validate } from './validation';

type UseInterviewFormProps = {
  selectedInterviewType: InterviewType | null;
};

export const useInterviewForm = ({ selectedInterviewType }: UseInterviewFormProps) => {
  const [interviewValue, setInterviewValue] = useState<InterviewValue>({
    address: '',
    phone: '',
  });
  const [errors, setErrors] = useState<InterviewError>({
    address: {
      error: '',
      reset: () => setErrors((v) => ({ ...v, address: { ...v.address, error: '' } })),
    },
    phone: {
      error: '',
      reset: () => setErrors((v) => ({ ...v, phone: { ...v.phone, error: '' } })),
    },
  });

  const dictionary = useDictionary();
  const { data: currentUser } = useCurrentUserQuery();

  useEffect(() => {
    if (selectedInterviewType === InterviewType.InPerson) {
      setInterviewValue((v) => ({ ...v, meetingTitle: dictionary.introductionAtTheLocation }));
    } else if (selectedInterviewType === InterviewType.Call) {
      setInterviewValue((v) => ({ ...v, meetingTitle: dictionary.telephoneConversationAboutTheVacancy }));
    }
  }, [selectedInterviewType, dictionary]);

  useEffect(() => {
    if (currentUser) {
      setInterviewValue((v) => ({ ...v, phone: currentUser.phone_number ?? v.phone }));
    }
  }, [currentUser?.phone_number]);

  const validateAndSetErrors = (interviewType: InterviewType | null) => {
    const validationErrors = validate(interviewType, interviewValue);
    setErrors((v) => ({
      address: { ...v.address, error: validationErrors?.address ?? '' },
      phone: { ...v.phone, error: validationErrors?.phone ?? '' },
    }));
    return validationErrors;
  };

  return {
    interviewValue,
    setInterviewValue,
    errors,
    validateAndSetErrors,
  };
};
